import { buildCreatableOptions, comboboxKey, initGameFormCombobox, normalizeComboboxName, parseComboboxNames } from './game-form-combobox.js';

(function () {
    document.querySelectorAll('[data-game-form-dictionary-field]').forEach((field) => {
        const input = field.querySelector('[data-game-form-dictionary-input]');
        const toggle = field.querySelector('[data-game-form-dictionary-toggle]');
        const list = field.querySelector('[data-game-form-dictionary-options]');

        if (
            !(field instanceof HTMLElement)
            || !(input instanceof HTMLInputElement)
            || !(toggle instanceof HTMLButtonElement)
            || !(list instanceof HTMLUListElement)
        ) {
            return;
        }

        const plural = field.dataset.gameFormDictionaryKind === 'platform' ? 'platforms' : 'hardware entries';
        const suggestionNames = parseComboboxNames(field.dataset.gameFormSuggestions ?? '[]');

        initGameFormCombobox({
            root: field,
            input,
            toggle,
            list,
            buildOptions: (query) => buildCreatableOptions({ query, names: suggestionNames, emptyLabel: `No ${plural} yet.` }),
            isCurrent: (option) => comboboxKey(option.value) === comboboxKey(input.value),
            onSelect: (option) => {
                input.value = normalizeComboboxName(option.value);
                if (option.type === 'create') {
                    suggestionNames.push(input.value);
                }
            },
        });
    });
})();
